<ng-container *ngIf="dataSource$ | async as rows">
<table
  mat-table
  [dataSource]="rows"
  matSort
  cdkDropList
  cdkDropListOrientation="horizontal"
  (cdkDropListDropped)="listDropped($event)"
>
  <ng-container matColumnDef="runNumber">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let item">{{ item.runNumber != null ? '#' + item.runNumber : '-' }}</td>
  </ng-container>

  <ng-container matColumnDef="id">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Export Instance ID</th>
    <td mat-cell *matCellDef="let item">{{ item._id }}</td>
  </ng-container>

  <ng-container matColumnDef="mode">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Mode</th>
    <td mat-cell *matCellDef="let item">{{ formatExportMode(item) }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let item">{{ formatExportStatus(item) }}</td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Created at</th>
    <td mat-cell *matCellDef="let item">{{ item.createdAt | date: 'medium' }}</td>
  </ng-container>

  <ng-container matColumnDef="finishedAt">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Finished at</th>
    <td mat-cell *matCellDef="let item">{{ item.finishedAt | date: 'medium' }}</td>
  </ng-container>

  <ng-container matColumnDef="download">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Download Link</th>
    <td mat-cell *matCellDef="let item">
      <div
        *ngIf="item.status == 'COMPLETED' && !item.isDownloading"
        class="download"
        (click)="download(item, $event)"
      >
        {{ item.key }}
      </div>
      <div *ngIf="item.isDownloading">
        Preparing download… Please wait, this may take a few minutes for large files.
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="headings"></tr>
  <tr
    mat-row
    class="row"
    *matRowDef="let row; columns: headings"
    (click)="rowClick(row)"
  ></tr>

  <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
    <td class="mat-cell" [attr.colspan]="headings.length">
      <span>No matching data.</span>
    </td>
  </tr>
</table>

<suvo-bi-skeleton-table-rows
  *ngIf="isLoading && rows.length === 0"
  [rowCount]="pageSize"
  [columnWidths]="[10, 10, 10]"
/>

</ng-container>

<mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons />
